import styled from 'styled-components';
import { ClickableTextMixin } from 'components/base/common-styles';
// TODO: change to esm import
const { SIZES } = require('common/constants/sizes');

export const StyledCell = styled.div`
  font-size: ${SIZES.medium};
  display: flex;
  align-items: center;
  height: 100%;
  ${ClickableTextMixin}
`;
